import React from "react";
import classNames from "classnames";
import "./styles.scss";

interface Props {
  className?: string;
  children: React.ReactNode;
  onClick?: React.EventHandler<any>;
  disabled?: boolean;
}

export const LinkButton = ({
  className,
  onClick,
  disabled,
  children,
}: Props) => {
  return (
    <button
      className={classNames("link-button", className)}
      disabled={disabled}
      onClick={onClick}
    >
      <span>{children}</span>
    </button>
  );
};
